import React from 'react'
import { Link } from 'react-router-dom'

const NotFound = () => {
  return (
    <div className="container" style={{ textAlign: 'center', paddingTop: '5rem' }}>
      <h1 style={{ fontSize: '5rem', marginBottom: '1rem' }}>404</h1>
      <h2>Page Not Found</h2>
      <p style={{ marginBottom: '2rem', color: 'var(--text-secondary)' }}>
        The page you're looking for doesn't exist.
      </p>
      <Link 
        to="/" 
        style={{
          display: 'inline-block',
          padding: '0.75rem 2rem',
          background: 'linear-gradient(135deg, var(--primary-color), var(--accent-color))',
          color: 'white',
          textDecoration: 'none',
          borderRadius: 'var(--radius-md)',
          fontWeight: 'var(--font-medium)'
        }}
      >
        Go Home
      </Link>
    </div>
  )
}

export default NotFound